import { render, staticRenderFns } from "./OwnerEdit.vue?vue&type=template&id=01bc4984&"
import script from "./OwnerEdit.vue?vue&type=script&lang=js&"
export * from "./OwnerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports